import { render, staticRenderFns } from "./StaffMenu.vue?vue&type=template&id=3470e818&"
import script from "./StaffMenu.vue?vue&type=script&lang=js&"
export * from "./StaffMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports